export default {"src":"/_next/static/media/weather.438eb1a3.svg","height":59,"width":59,"blurWidth":0,"blurHeight":0};